/**
 * application guid
 */

import { createSlice } from "@reduxjs/toolkit";

export const guidSlice = createSlice({
  name: "guid",
  initialState: {
    value: null,
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { update } = guidSlice.actions;

export default guidSlice.reducer;
